import React from 'react';
import MediaGallery from '$app/components/vendor/MediaGallery';
import config from '$config';
import { GalleryContainer, GalleryCard, GalleryTitle } from './styled';

export default ({ media = [] }) => {
  const prepareMedia = (media) =>
    media.map((img) => {
      const date = new Date();
      const unixTimestamp = Math.floor(date.getTime() / 1000);

      const baseUrl = `${config.gateUrl}/images${img.bucketPath}?cacheBust=${unixTimestamp}`;
      return {
        ...img,
        src: `${baseUrl}`,
        thumb: `${baseUrl}&size=500x200`,
      };
    });

  const preparedMedia = prepareMedia(media);
  if (!preparedMedia.length) return null;

  return (
    <GalleryContainer>
      <GalleryCard>
        <GalleryTitle>Image gallery</GalleryTitle>
        <MediaGallery media={preparedMedia} showIcons readOnly />
      </GalleryCard>
    </GalleryContainer>
  );
};
